import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/login";
import SignupPage from "./pages/signup";
import { AuthProvider } from "./components/providers/AuthProvider";
import { ApiProvider } from "./components/providers/ApiProvider";
import GateKeeper from "./components/gate_keeper";
import OverviewPage from "./pages/dashboard/overview";
import PcsPage from "./pages/dashboard/pcs";
import BatteryPage from "./pages/dashboard/battery";
import GridPage from "./pages/dashboard/grid";
import SolarPage from "./pages/dashboard/solar";
import LoadPage from "./pages/dashboard/load";
import RootLayout from "./pages/root_layout";
import Dashboard from "./pages/dashboard";
import LocationPage from "./pages/dashboard/location";
import DevicesPage from "./pages/dashboard/devices";
import ControlPage from "./pages/dashboard/control/ControlPage";
import TerminalPage from "./pages/dashboard/terminal/TerminalPage";
import UtilityBillPage from "./pages/dashboard/utility_bill";
import ColorModeProvider from "./components/providers/ColorModeProvider";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ApiProvider>

          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />

              <Route element={<GateKeeper />} >
                <Route element={<RootLayout />}>

                  <Route path="/index" element={<Navigate to="/dashboard" replace />} />
                
                  <Route path="/dashboard" element={<ColorModeProvider><Dashboard /></ColorModeProvider>}>

                    <Route path="/dashboard/locations" element={<LocationPage />} />
                    <Route path="/dashboard/overview" element={<OverviewPage />} />
                    <Route path="/dashboard/utility_bill" element={<UtilityBillPage />} />
                    <Route path="/dashboard/grid" element={<GridPage />} />
                    <Route path="/dashboard/load" element={<LoadPage />} />
                    <Route path="/dashboard/solar" element={<SolarPage />} />
                    <Route path="/dashboard/battery" element={<BatteryPage />} />
                    <Route path="/dashboard/pcs" element={<PcsPage />} />
                    <Route path="/dashboard/control" element={<ControlPage />} />
                    <Route path="/dashboard/devices" element={<DevicesPage />} />
                    <Route path="/dashboard/terminal" element={<TerminalPage />} />

                  </Route>
                </Route>

              </Route>

              <Route path="*" element={<Navigate to="/index" />} />

            </Routes>
          </BrowserRouter>

        </ApiProvider>
      </AuthProvider>
    </div>
  );
}

export default App;